<template>
    <div class="valid-input" :class="{'error':error}" @change="validation()">
        <slot></slot>
        <img src="../assets/error.png" v-show="error" alt="">
    </div>
</template>

<script>
    export default {
        name: "Valid",
        props:{
            max:{
                type:Number,
                required:false
            },
            min:{
                type:Number,
                required:false
            },
            validator:{
                type:Function,
                required:false
            },
            content:{
                required:true
            },
            isfirstLoad:{
                type:Boolean
            }
        },
        watch:{

        },
        data(){
            return {
                error:false
            }
        },
        methods:{
            validation(){
                if (this.min && this.content.length < this.min){
                    this.error = true;
                }else if (this.max && this.content.length > this.max){
                    this.error = true;
                }else this.error = !!(this.validator && !this.validator(this.content));
                return this.error;
            },
        }
    }
</script>

<style scoped lang="scss">
    .valid-input{
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        line-height: 13.33vw;
        img{
            width: 4.53vw;
            height: 4.53vw;
            margin: 0 1vw;
        }
    }
    .error>*{
        color: #ff4b33;
        &::placeholder{
            color: #ff4b33;
        }
        &:-moz-placeholder{
            color: #ff4b33;
        }
        &::-webkit-input-placeholder{
            color: #ff4b33;
        }
        &:-ms-input-placeholder{
            color: #ff4b33;
        }
    }
</style>